/* Copyright (c) 2019-2025, NVIDIA CORPORATION.  All rights reserved.
 *
 * NVIDIA CORPORATION and its licensors retain all intellectual property
 * and proprietary rights in and to this software, related documentation
 * and any modifications thereto.  Any use, reproduction, disclosure or
 * distribution of this software and related documentation without an express
 * license agreement from NVIDIA CORPORATION is strictly prohibited.
 */

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Commands } from 'bridge-commands/commands';
import { Types as CommandTypes } from 'bridge-commands/types';
import { BrowserPlugin } from 'crimson/lib/bridge/browser-plugin/browser-plugin';
import { FullBridgeCommand } from 'crimson/lib/bridge/bridge.service';
import { PluginHandlers, PluginResponse } from 'crimson/lib/bridge/common/plugin.models';
import { ServiceWorkerService } from 'service-worker/lib/service-worker.service';
import { PostMessageData, SwMessageType } from 'service-workers/sw.types';
import { BrowserDbUpdateMessage } from '../models';
import { SharedStorageUpdateMessages } from '../shared';

import Types = CommandTypes.Common.Sharedstorage;
const Sharedstorage = Commands.Common.Sharedstorage;

@Injectable({
    providedIn: 'root'
})
export class SharedStoragePlugin extends BrowserPlugin {
    constructor(private swService: ServiceWorkerService) {
        super();
    }

    public get handlers(): PluginHandlers {
        return {
            module: Sharedstorage.PostCacheUpdate.module,
            commands: {
                [Sharedstorage.PostCacheUpdate.method]: this.postCacheUpdateMessage.bind(this)
            }
        };
    }

    private postCacheUpdateMessage(
        command: FullBridgeCommand<Types.PostCacheUpdateParameters>
    ): Observable<PluginResponse> {
        const operationType = command.payload.operationType;

        const messageContent: BrowserDbUpdateMessage = {
            source: BrowserPlugin.browserInstanceId,
            path: command.payload.path,
            data: command.payload.cacheUpdateData ?? {},
            operationType
        };
        const message: PostMessageData = {
            type: SwMessageType.SharedStorageUpdate,
            content: JSON.stringify(messageContent)
        };
        // Do not post Cache message to all clients, this is a very expensive operation
        // and buggy due to the size of the cache object.
        if (operationType !== Types.OperationType.Cache) {
            this.swService.postMessageSw(message);
        }
        SharedStorageUpdateMessages.next(messageContent);
        return this.makeResult('true');
    }
}
